export type Role = 'admin' | 'manager' | 'worker'
export const userProfileOptions = [
  'Administrador', 'Gerente', 'Diretor de Arte', 'Planejamento', 'Atendimento', 'Diagramador', 'Redator', 'Revisor',
  'Coordenador', 'Diretor de Comunicação', 'Supervisor Diagramação', 'Head Criação', 'Head Brand', 'Head Estratégia',
  'Performance & Growth', 'Motion Designer', 'RTV',
] as const
export type UserProfile = typeof userProfileOptions[number]
export const userLevelOptions = ['Júnior', 'Pleno', 'Sênior'] as const
export type UserLevel = typeof userLevelOptions[number]
export type Page = 'dashboard' | 'campaigns' | 'tasks' | 'reports' | 'talentDesk' | 'settings'
export type TaskStatus = 'Backlog' | 'Em espera' | 'Em execução' | 'Em alteração' | 'Em análise' | 'Aprovada' | 'Reprovada'
export type WorkCategory = 'Diagramação' | 'Revisão' | 'Criação/Redação' | 'Gestão/Planejamento'
export type ReportArea = 'Mídia e Promoção' | 'Digital' | 'Branding Institucional' | 'Gestão de Demandas' | 'Farmácia' | 'Marcas Próprias' | 'Trade' | 'Patrocínios' | 'Comunicação Visual' | 'Comunicação Regional'
export type DeliverableFormat = 'Jornal' | 'LED' | 'Carrossel' | 'Rádio' | 'TikTok/Reels' | 'TV' | 'YouTube' | 'Anúncio' | 'Cartela Live' | 'Outro'
export type MaterialCategory = 'Mídia ON' | 'Mídia OFF' | 'DOOH' | 'Textos' | 'Tabloides' | 'Mídias Com Ofertas' | 'Criações Institucionais'
export type SubtaskKind = 'Planejamento' | 'Redação' | 'Criação' | 'Diagramação' | 'Revisão'

export interface TaskTimeEntry {
  id: string
  user: string
  status: TaskStatus
  seconds: number
  startedAt: string
}

export interface SubtaskTimeEntry {
  id: string
  user: string
  status: TaskStatus
  seconds: number
  startedAt: string
  startedOn?: string
  running: boolean
}

export interface TaskActivityEntry {
  id: string
  user: string
  status: TaskStatus
  description: string
  occurredAt: string
  occurredOn?: string
  statusChange?: {
    entity: 'task' | 'deliverable'
    entityId: string
    entityTitle: string
    from: TaskStatus
    to: TaskStatus
  }
}

export interface Subtask {
  id: string
  parentId?: string
  dueAt?: string
  title: string
  materialCategory?: MaterialCategory
  reportArea?: ReportArea
  createdBy: string
  owner: string
  reviewer?: string
  supportUsers: string[]
  status: TaskStatus
  seconds: number
  running: boolean
  timeEntries?: SubtaskTimeEntry[]
  format: DeliverableFormat
  kind: SubtaskKind
  volume: number
  pages: number
  completedAt?: string
  analysisApprovedAt?: string
  analysisApprovedBy?: string
}

export interface User {
  name: string
  email: string
  role: UserProfile
  level: UserLevel
  initials: string
  systemRole: Role
  mock: boolean
}

export interface Client {
  id: string
  name: string
  logo?: string
  operations: string[]
}

export interface ClientAccessScope {
  allOperations: boolean
  operations: string[]
}

export interface UserAccessScope {
  allClients: boolean
  clients: Record<string, ClientAccessScope>
}

export type UserAccessScopes = Record<string, UserAccessScope>

export interface RegisteredAccount {
  email: string
  name: string
  initials: string
  picture?: string
  profile: UserProfile
  level: UserLevel
  accessScope: UserAccessScope
  lastLoginAt: string
  systemRole?: Role
}

export interface SystemNotification {
  id: string
  recipient: string
  taskId: string
  campaignId: string
  title: string
  message: string
  createdAt: string
  createdOn: string
  readAt?: string
}

export interface CampaignAlterationItem {
  subtaskId: string
  subtaskTitle: string
  owner: string
  reason: string
  resolvedAt?: string
}

export interface CampaignAlteration {
  id: string
  requestedBy: string
  createdAt: string
  createdOn: string
  items: CampaignAlterationItem[]
}

export interface Campaign {
  id: string
  name: string
  code: string
  clientId: string
  operation?: string
  reportArea?: ReportArea
  startDate?: string
  startTime?: string
  endDate?: string
  endTime?: string
  progress: number
  createdBy?: string
  members: string[]
  status: 'Em andamento' | 'Pausada' | 'Concluída'
}

export interface Task {
  id: string
  title: string
  description?: string
  campaignId: string
  category: WorkCategory
  reportArea?: ReportArea
  priority: 'Alta' | 'Média' | 'Baixa'
  status: TaskStatus
  due: string
  owner: string
  seconds: number
  running: boolean
  runningUser?: string
  activeTimeEntryId?: string
  timeEntries: TaskTimeEntry[]
  activityEntries: TaskActivityEntry[]
  alterations: CampaignAlteration[]
  subtasks: Subtask[]
}
